export default "__VITE_ASSET__DTUiqp2t__"